const Data = [
    {
        name: "Akshat Verma",
        linkedinLink: "http://www.linkedin.com/in/akshatvermaa",
        email: "akshat.verma@gyws.org",
        imageUrl: "/assets/images/members/Heads24/Akshat Verma.jpg",
        position: "SRC Head"
      },
    
      {
        name: "Ritil Ranjan",
        facebookLink: "https://www.facebook.com/ritil.ranjan.1?mibextid=JRoKGi",
        linkedinLink: "https://www.linkedin.com/in/ritil-ranjan-0b197924b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        email: "ritil.ranjan@gyws.org",
        imageUrl: "/assets/images/members/Heads24/Ritil ranjan.jpg",
        position: "SRC Head"
      },
      {
        name: "Jaydeep Parmar",
        facebookLink: "https://www.facebook.com/profile.php?id=100017491156001",
        linkedinLink: "https://www.linkedin.com/in/jaydeep-parmar37",
        email: "jaydeep.parmar@gyws.org",
        imageUrl: "/assets/images/members/Heads24/Jaydeep parmar.jpg",
        position: "SRC Head"
      },
      {
        name: "Simran Jangral",
        position: "SRC Head",
        imageUrl: "/assets/images/members/Heads24/Simran Jangral.png",
        facebookLink: "https://www.facebook.com/profile.php?id=100087633905026",
        linkedinLink: "https://www.linkedin.com/in/simran-jangral",
        email: "simran.jangral@gyws.org"
    },
    {
        "name": "Biswajit Das",
        "position": "SRC Head",
        "imageUrl": "/assets/images/members/Heads24/BiswajitDas.jpg",
        "facebookLink": "https://www.facebook.com/profile.php?id=100034915032616&mibextid=ZbWKwL",
        "linkedinLink": "https://www.linkedin.com/in/biswajit-das-204b9b252?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        "email": "biswajit.das@gyws.org"
    }
  
    
]

export default Data;